import { render, staticRenderFns } from "./SmtpSetting.vue?vue&type=template&id=68085a50&scoped=true&"
import script from "./SmtpSetting.vue?vue&type=script&lang=js&"
export * from "./SmtpSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68085a50",
  null
  
)

export default component.exports